// Webinars, the third tab of Recordings and dates (AdminWebinars.dc.html), at /admin/webinars and
// /admin/webinars/<webinar id>. Owner, admin and support (support reads). A replay's register page
// (docs/replay-register-spec.md 5) has its registrations at /admin/webinars/<webinar id>/registrations,
// for owner and admin. The property strategy tool's completions (Stage 2, docs/property-strategy-spec.md S2.9) are at
// /admin/webinars/strategy-tool, for owner and admin, drawn before the webinars load. The pieces are in src/admin/content/.
import { useAdmin, Loading, Problem, useLoad } from '../ui/index.js'
import { ContentHead } from '../content/Head.jsx'
import { WebinarsView } from '../content/WebinarsView.jsx'
import { ReplayRegistrations } from '../content/ReplayRegistrations.jsx'
import { StrategyCompletions } from '../content/StrategyCompletions.jsx'
import { loadWebinars } from '../content/data.js'
import '../../styles/admin-content.css'

export default function Webinars({ role, route, api }) {
  const { personId } = useAdmin()
  const strategy = route.params.tab === 'strategy'
  const webinars = useLoad(() => (strategy ? Promise.resolve(null) : loadWebinars(api, role)), [api, role, strategy])
  const id = route.params.id || null
  let body
  if (strategy) body = <StrategyCompletions api={api} role={role} />
  else if (webinars.status === 'loading' && !webinars.data) body = <Loading />
  else if (!webinars.data) body = <Problem error={webinars.error} onRetry={webinars.reload} />
  else if (route.params.tab === 'registrations') body = <ReplayRegistrations webinar={webinars.data.webinars.find(w => w.id === id) || null} api={api} role={role} />
  else body = <WebinarsView data={webinars.data} reload={webinars.reload} api={api} role={role} personId={personId} initialId={id} />
  return (
    <>
      <ContentHead role={role} current="webinars" note={!strategy} />
      {body}
    </>
  )
}
